import { render, staticRenderFns } from "./antistopLink.vue?vue&type=template&id=e2895522"
import script from "./antistopLink.vue?vue&type=script&lang=js"
export * from "./antistopLink.vue?vue&type=script&lang=js"
import style0 from "./antistopLink.vue?vue&type=style&index=0&id=e2895522&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports